export default __webpack_public_path__ + "static/machu-pichu-0bb3fadcdbc96b81747a10b98f028bc9.jpg";